import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

export const OutlookIcon: React.FC<IconProps> = ({ size = 24, className, style }) => (
  <img
    src="/images/outlook-icon.png"
    alt="Outlook"
    width={size}
    height={size}
    className={className}
    style={{
      objectFit: 'contain',
      borderRadius: '3px',
      ...style
    }}
  />
);

export const GmailIcon: React.FC<IconProps> = ({ size = 24, className, style }) => (
  <img
    src="/images/gmail-icon.png"
    alt="Gmail"
    width={size}
    height={size}
    className={className}
    style={{
      objectFit: 'contain',
      borderRadius: '3px',
      ...style
    }}
  />
);

export const InstagramIcon: React.FC<IconProps> = ({ size = 24, className, style }) => (
  <img
    src="/images/instagram-icon.png"
    alt="Instagram"
    width={size}
    height={size}
    className={className}
    style={{
      objectFit: 'contain',
      borderRadius: '3px',
      ...style
    }}
  />
);

export const TikTokIcon: React.FC<IconProps> = ({ size = 24, className, style }) => (
  <img
    src="/images/tiktok-icon.png"
    alt="TikTok"
    width={size}
    height={size}
    className={className}
    style={{
      objectFit: 'contain',
      borderRadius: '3px',
      ...style
    }}
  />
);

export const TwitchIcon: React.FC<IconProps> = ({ size = 24, className, style }) => (
  <img
    src="/images/twitch-icon.png"
    alt="Twitch"
    width={size}
    height={size}
    className={className}
    style={{
      objectFit: 'contain',
      borderRadius: '3px',
      ...style
    }}
  />
);

export const ShopifyIcon: React.FC<IconProps> = ({ size = 24, className, style }) => (
  <img
    src="/images/shopify-icon.png"
    alt="Shopify"
    width={size}
    height={size}
    className={className}
    style={{
      objectFit: 'contain',
      borderRadius: '3px',
      ...style
    }}
  />
);

export const StripeIcon: React.FC<IconProps> = ({ size = 24, className, style }) => (
  <img
    src="/images/stripe-icon.jpeg"
    alt="Stripe"
    width={size}
    height={size}
    className={className}
    style={{
      objectFit: 'contain',
      borderRadius: '3px',
      ...style
    }}
  />
);

export const BitlyIcon: React.FC<IconProps> = ({ size = 24, className, style }) => (
  <img
    src="/images/bitly-icon.png"
    alt="Bitly"
    width={size}
    height={size}
    className={className}
    style={{
      objectFit: 'contain',
      borderRadius: '3px',
      ...style
    }}
  />
);

export const EmailProviderIcon: React.FC<IconProps & { provider: 'outlook' | 'gmail' }> = ({ 
  provider, 
  size = 24, 
  className, 
  style 
}) => {
  switch (provider) {
    case 'outlook':
      return <OutlookIcon size={size} className={className} style={style} />;
    case 'gmail':
      return <GmailIcon size={size} className={className} style={style} />;
    default:
      // No generic fallback - only show specific provider icons
      return null;
  }
};

export const PlatformIcon: React.FC<IconProps & { platform: string }> = ({ 
  platform, 
  size = 24, 
  className, 
  style 
}) => {
  // Add defensive check for undefined platform
  if (!platform || typeof platform !== 'string') {
    console.warn('PlatformIcon: platform prop is undefined or not a string:', platform);
    return null;
  }

  switch (platform.toLowerCase()) {
    case 'instagram':
      return <InstagramIcon size={size} className={className} style={style} />;
    case 'tiktok':
      return <TikTokIcon size={size} className={className} style={style} />;
    case 'twitch':
      return <TwitchIcon size={size} className={className} style={style} />;
    case 'shopify':
      return <ShopifyIcon size={size} className={className} style={style} />;
    case 'stripe':
      return <StripeIcon size={size} className={className} style={style} />;
    case 'bitly':
      return <BitlyIcon size={size} className={className} style={style} />;
    default:
      // No generic fallback - only show specific platform icons
      return null;
  }
};

// Helper function to detect email provider from email address or domain
export const detectEmailProvider = (identifier: string): 'outlook' | 'gmail' | null => {
  const lowerIdentifier = identifier.toLowerCase();
  
  // Check for Outlook/Microsoft domains
  if (lowerIdentifier.includes('outlook') || 
      lowerIdentifier.includes('hotmail') || 
      lowerIdentifier.includes('live.com') ||
      lowerIdentifier.includes('msn.com')) {
    return 'outlook';
  }
  
  // Check for Gmail
  if (lowerIdentifier.includes('gmail')) {
    return 'gmail';
  }
  
  // Return null if no specific provider is detected
  return null;
}; 